/* eslint-disable @typescript-eslint/no-unused-vars */

import { useNavigate } from "react-router-dom";
import { APP_CONSTANTS } from "../../constants";
import { idType } from "../../types";
import { SharedTable } from "../shared/tables/sharedTable";
import { role, tableAction, tableType as tableTypeE  } from "../../enums";
import { useGetUsersQuery } from "../../store/api/userApi";
import UpdateIcon from "../../assets/img/svg/updateIcon.svg";
import { FaUserPlus } from "react-icons/fa";
import useSharedDynamicModal from "../../hooks/useSharedDynamicModal";


interface IUsersListTableProps { }

/**
 *
 * @param props
 * @returns
 */
export const UsersTable = (props: IUsersListTableProps)  => {



  const nav = useNavigate();



  /**
   *
   * @param userId
   */
  const onRowClick = (userId: idType) => {

  };
  const { openSharedDynamicModal } =
    useSharedDynamicModal();
  /**
   *
   */
  const handleCreateNewUserClick = () => {
    openSharedDynamicModal({
      title: (
        <>
          <FaUserPlus color="#1AA5C0" size={30} />
          {"Nouveau utilisateur"}
        </>
      ),
      isFormModal: true,
      size: "lg",
      message: "",
      component: (
        <>
          
        </>
      ),

      confirmButton: null,
      cancelButton: null,
    });
  };

  return (
    <SharedTable
      fetchHook={useGetUsersQuery}
      onRowClick={onRowClick}
      fetchSingleEntityHook={() => {}}
      tableType={tableTypeE.USERS }
      rowActions={
         [
              {
                name: tableAction.UPDATE_ROW,
                buttonText: "Modifier",
                buttonColor: "bg-[#50799E]",
                buttonIcon: UpdateIcon,
                handler: (userId: idType) => {
                 
                },
              },
            ]
          
      }
      tooltipActionButtons={[
        {
          text: "Nouveau utilisateur",
          handler: handleCreateNewUserClick,
        },
      ]}
      isPaginated={true}
      tableHeaders={APP_CONSTANTS.TABLES.users.headers}
      tableName={"Users List"}
    />
  );
};
